<template>
  <el-dialog class="header_detail"
             :visible.sync="detailVisible"
             :close-on-click-modal="false"
             @closed="closeDialog"
             width="800px"
             @open="openCb"
             title="工单详情"
             v-loading="loading">
    <el-form :model="detailForm"
             ref="detailForm"
             label-width="0"
             class="formCont">

      <div class="leftCont">
        <div class="dialogTitle">
          <div @click="edit('level')"
               class="levelTagCont">
            <el-tag effect="dark"
                    type="danger"
                    size="mini"
                    v-if="detailForm.priority == 'High'">
              High
            </el-tag>
            <el-tag effect="dark"
                    type="success"
                    size="mini"
                    v-else-if="detailForm.priority == 'Middle'">
              Middle
            </el-tag>
            <el-tag effect="dark"
                    type="info"
                    size="mini"
                    v-else-if="detailForm.priority == 'Low'">
              Low
            </el-tag>
          </div>
          <!-- <el-form-item v-show="levelEdit == 'edit'"
                        style="width:100px;margin:0 10px">
            <el-select v-model="detailForm.priority"
                       placeholder="请选择"
                       size="mini"
                       @blur="blur('level')"
                       ref="level"
                       @visible-change="priorityChange">
              <el-option v-for="val in priorityList"
                         :key="val"
                         :label="val"
                         :value="val">
              </el-option>
            </el-select>
          </el-form-item> -->
          <div class="title"
               @click="edit('title')">
            【{{detailForm.id}}】{{detailForm.title}}
          </div>
          <!-- <el-form-item v-show="titleEdit == 'edit'"
                        style="width:400px;margin:0 10px"
                        prop="title"
                        :rules="[{required: true, message: '请输入标题'}]">
            <el-input placeholder="请输入标题"
                      maxlength="50"
                      size="mini"
                      v-model="detailForm.title"
                      @blur="blur('title')"
                      ref="title">
            </el-input>
          </el-form-item> -->
        </div>
        <div class="main">
          <div class="mainTitle">
            详细信息
          </div>
          <div class="mainCont"
               style="min-height:100px">
            <!-- <div class="text">流程调整为：</div> -->
            <!-- <div class="detailCont"> -->
            <div v-html="detailForm.desc"
                 class="text">
              {{detailForm.desc}}
            </div>
          </div>
        </div>
        <div class="attachCont">
          <div class="attachItem">
            <div>附件：</div>
            <a :href="detailForm.document"
               v-if="detailForm.document">下载附件</a>
          </div>
          <!-- <div class="attachItem"
               v-else>
            <div>附件：</div>
            <el-upload style="display:inline-block"
                       :limit="1"
                       class="upload-demo"
                       ref="upload"
                       action
                       :file-list="fileList"
                       :http-request="uploadFile"
                       :before-remove="handleRemove">
              <el-button slot="trigger"
                         size="small"
                         plain>选取文件</el-button>
            </el-upload>
          </div> -->
          <!-- <div class="prompt"
               v-if="!detailForm.document">*仅支持pdf、excel、word、ppt、zip等格式的文件，大小不超过5MB</div> -->
          <div class="attachItem">
            来源： {{detailForm.depart}}/{{detailForm.user_name}}
          </div>
          <div class="attachItem">
            <div>状态：{{detailForm.status_cn}}</div>
            <!-- <el-radio-group v-model="detailForm.status"
                            size="small"
                            @change="dosth">
              <el-radio v-for="(val,key) in statusList"
                        :key="key"
                        :label="key">{{val}}</el-radio>
            </el-radio-group> -->

          </div>
          <div class="attachItem">
            总耗时：{{detailForm.takeup_time}}h
          </div>
        </div>
      </div>

      <!-- <div class="rightCont">
        <div class="title">变更历史</div>
        <ul v-for="(item,index) in historyList"
            :key="index">
          <li class="historyList">
            <div>{{item.time}}</div>
            <div>{{item.username}}</div>
            <div>{{item.content}}</div>
          </li>
        </ul>
      </div> -->
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button size="small"
                 type="primary"
                 @click="process">{{btn}}</el-button>
      <el-button size="small"
                 type="danger"
                 @click="refuse"
                 v-if="detailForm.status == 5">拒绝</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import * as api from "@/http/api.js";
import * as oaApi from "@/http/oaApi.js";
export default {
  data () {
    return {
      detailForm: {
        priority: 'Middle',
        title: '',
        desc: '',
        document: '',
        id: '',
        status: 1,
        depart: ''
      },
      historyList: [

      ],
      titleEdit: 'show',
      levelEdit: 'show',
      loading: false,

    }
  },
  methods: {
    closeDialog () {
      this.detailVisible = false
      this.$emit('update:detailVisible', this.detailVisible)
      this.detailForm = {
        priority: 'Middle',
        title: '',
        desc: '',
        document: '',
        id: '',
        status: 1,
        depart: ''
      }
      this.rela_code = ''
      this.$emit('update:rela_code', this.rela_code)

    },
    // edit (params) {
    //   if (params == "level") {
    //     this.levelEdit = "edit"
    //     this.$nextTick(() => {
    //       this.$refs.level.focus();
    //     });

    //   } else if (params == "title") {
    //     this.titleEdit = "edit"
    //     this.$nextTick(() => {
    //       this.$refs.title.focus();
    //     });

    //   }
    // },
    // blur (params) {
    //   if (params == "level") {
    //     this.levelEdit = "show"
    //   } else if (params == "title") {
    //     this.titleEdit = "show"
    //   }
    // },
    // priorityChange (val) {
    //   if (val == false) {
    //     this.$nextTick(() => {
    //       this.$refs.level.blur();
    //     });
    //     this.levelEdit = "show"
    //   }
    //   //   this.$nextTick(() => {
    //   //     this.$refs.level.blur();
    //   //   });
    // },
    // 上传
    // uploadFile (file) {
    //   let formData = new FormData();
    //   formData.append("files", file.file);
    //   const loading = this.$loading({
    //     lock: true,
    //     text: "正在上传中...",
    //     spinner: "el-icon-loading",
    //     background: "rgba(255, 255, 255, 0.5)"
    //   });
    //   api.uploadFile(formData).then(res => {
    //     if (res) {
    //       this.detailForm.document = res.data.path;
    //       //   this.commitForm.file_name = res.bus_json.file_name;
    //       // this.file_id = res.bus_json.file_id;
    //     }
    //     loading.close();
    //   });
    // },
    //删除时
    // handleRemove (file, fileList) {
    //   var data = {
    //     attacMentCode: this.attachMentCode
    //   }
    //   deleteAttachment(data).then(res => {
    //     if (res.msgCode == '1') {
    //       this.attachMentCode = ''
    //     } else if (res.msgCode == '0') {
    //     }
    //   })
    // },
    /**
     * 获取详情
     */
    getDetail () {
      oaApi.work({}, "get",
        this.rela_code
      ).then(res => {
        if (res) {
          this.detailForm = res.data
        }
      })
    },
    /**
     * 提交修改
     */
    // commitDetail () {
    //   this.$refs["detailForm"].validate(valid => {
    //     api.work(this.detailForm, "put", this.tableItem.id).then(res => {
    //       if (res) {
    //         this.closeDialog()
    //         // this.$parent.work();
    //       }
    //     })
    //   })
    // },
    /**
     * 获取变更历史
     */
    // history () {
    //   api.history({ wid: this.tableItem.id }, "get").then(res => {
    //     if (res) {
    //       this.historyList = res.data
    //     }
    //   })
    // }
    process () {
      let status = ''
      let text = ''
      if (this.detailForm.status == 1) {
        status = 5
        text = '响应'
      } else if (this.detailForm.status == 5) {
        status = 10
        text = '完成'
      } else if (this.detailForm.status == 10) {
        status = 15
        text = '验收'
      }
      this.$confirm(`确定${text}吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => oaApi.process({
          wid: this.detailForm.id,
          status: status
        }, 'post').then(res => {
          if (res) {
            if (res.code == 200) {
              this.$message.success(`${this.btn}成功`);
            }
            this.$bus.emit("work", true)
            // this.$parent.noticeTips()
            this.closeDialog()
          }
        }))
        .catch(() => {
          this.$message.info("已取消操作");
        });

    },
    refuse () {
      this.$confirm(`确定拒绝吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => oaApi.process({
          wid: this.detailForm.id,
          status: 20
        }, 'post').then(res => {
          if (res) {
            if (res.code == 200) {
              this.$message.error('已拒绝');
            }
            // this.$parent.noticeTips()
            this.closeDialog()
          }
        }))
        .catch(() => {
          this.$message.info("已取消操作");
        });


    }
  },
  props: [
    'detailVisible',
    'rela_code'
  ],
  watch: {
    rela_code: {
      handler (newValue) {
        this.rela_code = newValue;
        this.getDetail()
      },
      deep: true,
      immediate: false
    },
  },
  computed: {
    ...mapState({
      priorityList: state => state.index.priorityList, // 优先级列表
      statusList: state => state.index.statusList,  //状态列表
    }),
    btn: function () {
      let btnText = ''
      if (this.detailForm.status == 1) {
        btnText = '响应'
      } else if (this.detailForm.status == 5) {
        btnText = '完成'
      } else if (this.detailForm.status == 10) {
        btnText = '验收'
      }
      return btnText;
    }
  },
  beforeDestroy () {
    this.$bus.off('work');
  }
}
</script>
<style lang="scss">
.header_detail {
    width: 100%;
    // display: flex;
    // .el-dialog__body {
    //     display: flex;
    //     flex-wrap: wrap;
    // }
    .formCont {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        .leftCont {
            width: 100%;
            // border-right: 1px solid #e8e8e8;
            .dialogTitle {
                display: flex;
                align-items: center;
                // justify-content: space-between;
                margin-top: 20px;
                .levelTagCont,
                .title {
                    // cursor: pointer;
                }
                .leftContainer {
                    display: flex;
                    align-items: center;
                }
            }

            .main {
                width: 100%;
                border-bottom: 1px #e8e8e8 solid;
                .mainTitle {
                    text-align: left;
                    color: #3582fb;
                    line-height: 2;
                    border-bottom: 1px #e8e8e8 solid;
                    margin-top: 20px;
                }
                .mainCont {
                    // border-bottom: 1px #e8e8e8 solid;
                    // min-height: 200px;
                    .text {
                        text-align: left;
                        line-height: 2;
                    }
                }
            }
            .attachCont {
                // border-bottom: 1px #e8e8e8 solid;
                .attachItem {
                    display: flex;
                    text-align: left;
                    padding: 5px 0;
                    margin: 5px 0;
                    // height: 40px;
                    .upload-demo {
                        display: inline-flex !important;
                    }
                }
                .prompt {
                    color: red;
                    font-size: 8px;
                    text-align: left;
                }
            }
        }
        .rightCont {
            width: 29%;
            height: 100%;
            padding-left: 20px;
            box-sizing: border-box;
            // float: right;
            .title {
                color: #3582fb;
                text-align: left;
                margin-top: 20px;
            }
            .historyList {
                display: flex;
                justify-content: space-between;
                margin: 14px 0;
            }
        }
        .el-dialog__body {
            padding-top: 0;
        }
    }

    .editBtn {
        font-size: 14px;
        padding: 4px;
        margin-right: 10px;
        &:hover {
            background: #ddd;
            // cursor: pointer;
        }
    }
    .ck-editor__editable {
        min-height: 100px;
    }
    .el-radio {
        margin-right: 8px;
    }
}
</style>